import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import GraphqlReaderForm from '../forms/graphql-reader-form';
import { graphqlReaderValidationSchema } from '../schema/graphqlReader.js';

export default function GraphqlReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'GraphQL Reader Node Details',
        altText: 'GraphQL Reader Node',
        defaultLabel: 'GraphQL Reader Node',
      }}
    >
      <CommonNode
        FormComponent={GraphqlReaderForm}
        schemaResolver={graphqlReaderValidationSchema}
      />
    </NodeProvider>
  );
}
